document.addEventListener('DOMContentLoaded', function () {
    const header = document.getElementById('header');
    if (!header) {
        return;
    }

    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    var handleScroll = debounce(function() {
        if (window.scrollY > 60) {
            header.classList.add('smaller-header');
        }

        if (window.scrollY < 30) {
            header.classList.remove('smaller-header');
        }
    }, 250);

    window.addEventListener('scroll', handleScroll);

    const isDesktopNav = () => window.matchMedia('(min-width: 1280px)').matches;

    function setSubmenuOpen(navItem, open) {
        const toggle = navItem.querySelector('.submenu-toggle');
        const subMenu = navItem.querySelector('.sub-menu');
        const icon = toggle ? toggle.querySelector('.angle-icon') : null;

        navItem.classList.toggle('is-open', open);

        if (toggle) {
            toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        }

        if (subMenu && !isDesktopNav()) {
            subMenu.classList.toggle('hidden', !open);
        }

        if (icon) {
            icon.classList.toggle('fa-angle-up', open);
            icon.classList.toggle('fa-angle-down', !open);
        }
    }

    function closeAllSubmenus(exceptNavItem) {
        document.querySelectorAll('#header .nav-item.is-open').forEach(function (navItem) {
            if (navItem !== exceptNavItem) {
                setSubmenuOpen(navItem, false);
            }
        });
    }

    document.querySelectorAll('#header .nav-item').forEach(function (navItem) {
        const toggle = navItem.querySelector('.submenu-toggle');
        if (!toggle) {
            return;
        }

        toggle.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            if (toggle.getAttribute('data-menu-key-toggle') === '1') {
                toggle.removeAttribute('data-menu-key-toggle');
                return;
            }
            const isOpen = toggle.getAttribute('aria-expanded') === 'true';
            closeAllSubmenus(navItem);
            setSubmenuOpen(navItem, !isOpen);
        });

        navItem.addEventListener('mouseenter', function () {
            if (isDesktopNav()) {
                closeAllSubmenus(navItem);
                setSubmenuOpen(navItem, true);
            }
        });

        navItem.addEventListener('mouseleave', function () {
            if (isDesktopNav()) {
                setSubmenuOpen(navItem, false);
            }
        });

        navItem.addEventListener('focusout', function (event) {
            if (!navItem.contains(event.relatedTarget)) {
                setSubmenuOpen(navItem, false);
            }
        });

        const subMenu = navItem.querySelector('.sub-menu');
        const menuLinks = subMenu ? Array.from(subMenu.querySelectorAll('a[href]')) : [];

        toggle.addEventListener('keydown', function (event) {
            const isOpen = toggle.getAttribute('aria-expanded') === 'true';

            if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
                event.preventDefault();
                toggle.setAttribute('data-menu-key-toggle', '1');
                closeAllSubmenus(navItem);
                setSubmenuOpen(navItem, !isOpen);
                requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                        toggle.removeAttribute('data-menu-key-toggle');
                    });
                });
                return;
            }

            switch (event.key) {
                case 'Escape':
                    if (isOpen) {
                        event.preventDefault();
                        event.stopPropagation();
                        setSubmenuOpen(navItem, false);
                        toggle.focus();
                    }
                    break;

                case 'ArrowDown':
                    event.preventDefault();
                    if (!isOpen) {
                        closeAllSubmenus(navItem);
                        setSubmenuOpen(navItem, true);
                    }
                    if (menuLinks.length) {
                        menuLinks[0].focus();
                    }
                    break;

                case 'ArrowUp':
                    if (isOpen && menuLinks.length) {
                        event.preventDefault();
                        menuLinks[menuLinks.length - 1].focus();
                    }
                    break;
            }
        });

        menuLinks.forEach(function (link, index) {
            link.addEventListener('keydown', function (event) {
                switch (event.key) {
                    case 'Escape':
                        event.preventDefault();
                        event.stopPropagation();
                        setSubmenuOpen(navItem, false);
                        toggle.focus();
                        break;

                    case 'ArrowDown':
                        event.preventDefault();
                        menuLinks[index < menuLinks.length - 1 ? index + 1 : 0].focus();
                        break;

                    case 'ArrowUp':
                        event.preventDefault();
                        menuLinks[index > 0 ? index - 1 : menuLinks.length - 1].focus();
                        break;
                }
            });
        });
    });

    const menuToggle = document.getElementById('menuToggle');
    const mainNav = document.getElementById('mainNav');
    const mobileIcons = document.getElementById('mobileIcons');
    const mobileLogoClose = document.getElementById('mobileLogoClose');
    const closeMenu = document.getElementById('closeMenu');

    function setMobileMenuOpen(open) {
        mainNav.classList.toggle('hidden', !open);
        mobileIcons.classList.toggle('hidden', open);
        mobileLogoClose.classList.toggle('hidden', !open);
        if (menuToggle) {
            menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
    }

    if (menuToggle) {
        menuToggle.addEventListener('click', function () {
            setMobileMenuOpen(mainNav.classList.contains('hidden'));
        });
    }

    if (closeMenu) {
        closeMenu.addEventListener('click', function () {
            setMobileMenuOpen(false);
            if (menuToggle) {
                menuToggle.focus();
            }
        });
    }

    document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') {
            return;
        }

        const openItem = document.querySelector('#header .nav-item.is-open');
        if (openItem) {
            event.preventDefault();
            const toggle = openItem.querySelector('.submenu-toggle');
            setSubmenuOpen(openItem, false);
            if (toggle) {
                toggle.focus();
            }
            return;
        }

        if (!isDesktopNav() && mainNav && !mainNav.classList.contains('hidden')) {
            event.preventDefault();
            setMobileMenuOpen(false);
            if (menuToggle) {
                menuToggle.focus();
            }
        }
    });

    const searchToggles = document.querySelectorAll('#header .search-toggle');
    const searchBar = document.getElementById('searchBar');
    const searchInput = document.getElementById('header-search');

    function setSearchOpen(open) {
        if (!searchBar) {
            return;
        }

        searchBar.classList.toggle('hidden', !open);
        searchToggles.forEach(function (toggle) {
            toggle.classList.toggle('hidden', open);
            toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });

        if (open && searchInput) {
            searchInput.focus();
        }
    }

    searchToggles.forEach(function (toggle) {
        toggle.addEventListener('click', function (event) {
            event.preventDefault();
            setSearchOpen(searchBar.classList.contains('hidden'));
        });
    });

    const closeSearch = document.getElementById('closeSearch');
    if (closeSearch) {
        closeSearch.addEventListener('click', function () {
            setSearchOpen(false);
            const visibleToggle = Array.from(searchToggles).find(function (toggle) {
                return toggle.offsetParent !== null;
            });
            if (visibleToggle) {
                visibleToggle.focus();
            }
        });
    }

    fetch('/authcheck')
    .then(res => res.text())
    .then(isLoggedIn => {

        var loginButtons = document.querySelectorAll('.login-button');
        if (isLoggedIn === '1') {
            if (loginButtons) {
                loginButtons.forEach(function(button) {
                    button.href = '/memberships';
                    button.textContent = 'Profile';
                });
            }
        } else {
            if (loginButtons) {
                loginButtons.forEach(function(button) {
                    button.href = '/join';
                    button.textContent = 'Join / Login';
                });
            }
        }

    });

});
